// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"da0355f9","152":"64c7e96e","431":"2357b9e9","489":"183abb71","492":"dbdf3b64","608":"a4869af5","787":"5c3bf18d"}[chunkId] + ".chunk.js";
};